import 'hammerjs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { DataTableModule } from 'angular2-datatable';
import { TabsModule } from 'ngx-bootstrap';
import { AppComponent } from './app.component';
import { SharedComponentsModule } from './shared-components/shared-components.module';
import { ServicesModule } from './services/services.module';
import { AppRoutingModule } from './app-routing.module';
import { PagesModule } from './pages/pages.module';
import { BankAccountsRoutingModule } from './pages/client/my-settings/bank-accounts/bank-accounts-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';
//import { SignaturePadModule } from '@almothafar/angular-signature-pad';
//import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
// import { PostedinvoicesComponent } from './client/my-contracts/postedinvoices/postedinvoices.component';
import { EnvironmentComponent } from './pages/environment/environment.component';

@NgModule({
  declarations: [
    AppComponent
    //  PostedinvoicesComponent
   // EnvironmentComponent
//   ,SignaturePadComponent
  ],
  imports: [
    AppRoutingModule,
    DataTableModule,
    PagesModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    AngularFontAwesomeModule,
    BrowserModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    MatSidenavModule,
    ServicesModule.forRoot(),
    BrowserAnimationsModule
    , HttpModule
    , HttpClientModule
    , SharedComponentsModule
   // ,SignaturePadModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  exports: [
    DataTableModule,
    RouterModule,
    MatSidenavModule,
    ModalModule,
    AngularFontAwesomeModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    SharedComponentsModule
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts